import type { StandardCart } from '@/types/ShopFront/CheckoutStandards'
import { error, log } from '../Log'

/* eslint-disable no-underscore-dangle */
export function submitCart(cart: StandardCart) {
  try {
    cart.lineItems.forEach((item) => {
      window?._ltk?.SCA?.AddItemWithLinks(
        item.sku,
        item.quantity,
        item.salePrice,
        item.name,
        item.imageUrl,
        item.url,
      )
    })
    window?._ltk?.SCA?.Submit?.()
    log('submitted')
  } catch (err) {
    error('Failed to submit cart to listrak', err)
  }
}

export default submitCart
